<template>
    <div class="content3d-area relative" style="z-index:2; overflow:hidden;">
		<div style="position:absolute; top:0; left:50%; width:40px; height:20px; margin-left:-20px;">
		    <img :src="Arrow" />
		</div>
        <div class="b-container relative" style="padding-top:60px; padding-bottom:60px;">
            <div class="column v-center center mb-xxl">
                <div class="row">
                    <div class="h1 white ml-xxl">特色业务</div>
                    <div class="relative ml-md" style="width:44px; height:44px;">
                        <img :src="PlusRedIcon" style="width:44px; height:44px; position:absolute; top:-12px; left:0;" />
                    </div>
                </div>
             
            </div>

            <!-- SWIPER START -->
            <div class="relative swiper-container-wrap" id="case-swiper-wrap222">
                <div v-show="paginationBulletsLength !== 1" class="swiper-prev column center v-start">
                    <img :src="IconPrev" style="display:block; width:28px; height:48px;" />
                </div>

                <div v-show="paginationBulletsLength !== 1" class="swiper-next column center v-end">
                    <img :src="IconNext" style="display:block; width:28px; height:48px;" />
                </div>

                <div class="swiper-container" id="case-swiper222">
                    <div class="swiper-wrapper">
                        <div v-for="(item, index) in software" class="swiper-slide case-swiper222-slide" :key="index">
                            <!-- <div class="card-item" @click.stop="jumpDetail(item)"> -->
							   <div class="card-item"  >
                                <div class="row mb-lg software-cover slideCard_image">
                                    <div style="position:absolute; top:0; right:0; bottom:0; left:0; overflow:hidden;">
                                        <img :src="item.cover" class="card-photo" />
                                    </div>
                                </div>
                                <div class="row start white h4 mb-sm pr-lg title">
                                    {{ item.title }}
                                </div>
                                <div class="row start white t6 secondary pr-lg summary">
                                    {{ item.summary }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="paginationBulletsLength !== 1" class="mt-xxl row v-center center" style="height:16px;">
                        <div class="swiper-pagination333"></div>
                    </div>
                </div>
            </div>
            <!-- SWIPER END -->
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';

import {
    IconPrev,
    IconNext,
    PlusWhiteIcon,
    PlusRedIcon,
    Arrow,
    Software01,
    Software02,
    Software05,
    Software04,
	yiyelianmeng,
	gerenlipin,
	qiyefuli,
	gerensongli,
	hudongka,
	xitang,
	xipin1,

} from '@/constants/pics';

export default {
    name: 'zxservice',

    props: [],

    components: {},

    data() {
        return {
            swiper: null,

            IconPrev,
            IconNext,
            PlusWhiteIcon,
            PlusRedIcon,

            Arrow,

            currentItem: 0,
            activeIndex: -1,

            software: [
				{
				    cover: hudongka,
					title: '婚礼互动卡',
				     summary: '伴手礼卡可替代传统伴手礼，卡面根据活动主题定制，更具纪念意义，一卡一码，宾客扫码进入活动，领取专属红包，在系统内置的礼品商城任意挑选自己喜欢的礼品，为新人提供更人性话伴手礼解决方案。千挑万选，不如让TA自选。',
				},
				{
				    cover: xitang,
				    title: '奖励红包',
				    summary:
				         '主办方灵活 在互动场景植入奖励红包，覆盖签到、祝福、大合照、精彩拍等关键环节，互动性和趣味性大大增强。宾客可自由赞助红包，深度参与祝福氛围，增强社交互动和情感连接。',
				}

            ],
        };
    },

    computed: {
        paginationBulletsLength() {
            if (!this.swiper) {
                return 1;
            }

            return this.swiper.pagination.bullets.length;
        },
    },

    created() { },

    mounted() {
        this.$nextTick(function () {
            this.initSwiper();
        });

        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {
                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                    // this.$nextTick(function() {
                    //     this.initSwiper();
                    // });
                }, 300);
            }
        });
    },

    activated() { },

    deactivated() { },

    methods: {
        onArtistClick() {
            const id = 'test';

            this.$router.push({ path: '/artist' });
        },

        jumpDetail(item) {
            if (item.title == '出海上云') {
                this.$router.push({
                    path: '/serve',
query: {
                        title: item.title,
                    },
                });
            } else {
                this.$router.push({
                    path: '/detail',
query: {
                        title: item.title,
                    },
                });
            }
        },

        lightbox() {
            this.showLightbox = true;
        },

        close() {
            this.showLightbox = false;
        },

        initSwiper() {
            this.swiper = new Swiper('#case-swiper222', {


                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 0,

                slidesPerView: 'auto',
                threshold: 10,

                initialSlide: +this.currentItem,
                observer: true,
                observeParents: true,

                navigation: {
                    nextEl: '#case-swiper-wrap222 .swiper-next',
                    prevEl: '#case-swiper-wrap222 .swiper-prev',
                },

                pagination: {
                    el: '.swiper-pagination333',
                    clickable: true,
                },

                breakpoints: {
                    // when window width is >= 480px
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        // spaceBetween: 24,
                    },
                    479: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    480: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 720px
                    719: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    720: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1279: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1280: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    1392: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                    // when window width is >= 1280px
                    5120: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                        // spaceBetween: 24,
                    },
                },
            });

            if (this.swiper) {
                this.swiper.on(
                    'slideChange',
                    () => {
                        this.currentItem = this.swiper.activeIndex;
                    },
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.content3d-area {
    background: linear-gradient(to right, rgba(255, 51, 85, 1) 0%, rgba(241, 53, 54, 1) 100%);
    overflow: hidden;
}

// swiper-item
.swiper-container {
    width: 80%;
    height: 100%;
}

.swiper-slide {
    // width: 320px;
    // height: 380px;
    // text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    position: relative;
}

.swiper-slide:after {
    content: '';
    position: relative;
    // margin-top: 133.33%;
}

.swiper-next,
.swiper-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
    cursor: pointer;
    color: #333;
    width: 64px;
    height: auto;
    border-radius: 12px;
    border-radius: 0;
    will-change: transform;
    transition: all 300ms;
    outline: none;
}

.swiper-next:hover,
.swiper-prev:hover {
    width: 64px;
}

.swiper-next {
    right: -64px;
    left: auto;
    border-radius: 0;
    border-right: 0;
}

.swiper-prev {
    left: -64px;
    right: auto;
    border-radius: 0;
    border-left: 0;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

// content3d-cover
.content3d-cover {
    background: rgba(127, 127, 127, 0.1);
    overflow: hidden;
}

.content3d-cover:after {
    content: '';
    position: relative;
    margin-top: 100%;
}

.content3d-cover a {
    display: block;
    width: 240px;
    height: 380px;
}

@media (max-width: 991px) {
    .content3d-title {
        padding: 0 15px;
    }

    .h1 {
        font-size: 24px;
    }

    .scroll-wrap {
        width: 100%;
        height: auto;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .scroll-wrap .b-row {
        width: 1085px;
    }

    .b-container {
        padding-left: 0;
        padding-right: 0;
    }

    .b-row {
        margin-left: 0;
        margin-right: 0;
    }

    // .company-item-wrap {
    //     flex: 0 0 320px;
    // }
    //
    // .company-item {
    //     width: 240px;
    //     height: 380px;
    // }

    a.more {
        font-size: 16px;
    }

    .title {
        font-size: 16px;
    }

    .summary {
        font-size: 16px;
    }
}

.swiper-item {
    overflow: hidden;
}

.swiper-item .desc {
    will-change: transform;
    transition: all 300ms;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 80px;
    z-index: 3;
    background: rgba(255, 255, 255, 0.88);
    text-align: left;
}

.swiper-item.hover .desc {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 196px;
    z-index: 3;
    color: #fff;
    // background: linear-gradient(to bottom, rgba(255, 51, 85, 0.8) 0%, rgba(241, 53, 54, 0.9) 100%);
    background: rgba(0, 0, 0, 0.5);
}

.swiper-button-disabled img {
    opacity: 0.38;
}

.lightbox {
    display: none;
}

.lightbox.display {
    display: block;
}

.swiper-container-wrap {
    margin-left: -15px;
    margin-right: -15px;
}

@media (max-width: 991px) {
    .swiper-container-wrap {
        margin-left: 0;
        margin-right: 0;
    }
}

//
.swiper-pagination .swiper-pagination-bullet-active {
    background: #ffffff !important;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

.software-list a {
    text-decoration: none;
    color: #555;
}

.software-cover {
    background: rgba(127, 127, 127, 0.1);
    overflow: hidden;
}

.software-cover:after {
    content: '';
    position: relative;
    margin-top: 62.5%;
}

.software-cover a {
    display: block;
    width: 100%;
    height: 100%;
}

// slideCard_image
.card-item a:hover .slideCard_image:before {
    -webkit-transform: scaleX(1);
    -ms-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transform-origin: left;
    -ms-transform-origin: left;
    transform-origin: left;
    -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
        -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.slideCard_image {
    -webkit-transition-property: opacity;
    transition-property: opacity;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;

    position: relative;
    overflow: hidden;
}

.slideCard_image:before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    display: block;
    // background: linear-gradient(to right, rgba(255, 51, 85, 0.38) 0%, rgba(241, 53, 54, 0.2) 100%);
    // background: linear-gradient(to right, rgba(0, 0, 0, 0.38) 0%, rgba(0, 0, 0, 0.2) 100%);
    opacity: 1;
    -webkit-transform-origin: right;
    -ms-transform-origin: right;
    transform-origin: right;
    -webkit-transform: scaleX(0);
    -ms-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
        -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.card-item {
    padding: 0 15px;
}

.card-item a {
    text-decoration: none;
}

.card-item a .title {
    color: #000;
}

.card-item a .summary {
    color: #666;
}
</style>
